import axiosClient from "../axios-config";

export default {
  getProjects() {
    return axiosClient.get('/project');
  }
}